var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mic-container",on:{"click":_vm.recording}},[_c('div',{staticClass:"circle",class:{'active': _vm.active}},[_c('i',{staticClass:"fas fa-microphone"})]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holder"},[_c('div',{attrs:{"data-role":"recordings"}})])
}]

export { render, staticRenderFns }